import { FreeGameViewBehavior, SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";
import { dispatcher, EventConstants, SpineBase, ingenuity, detectDeviceEnvironmentConstants, Event, Label, IEvent, ISpineData, BaseCoreEventConstants, Loading, base } from "@quest/base-core";
import { SlotEventConstants } from "@quest/slot-core";
import { gameConstants } from "../Constants/gameConstants";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { WinPresentationPanelGame } from "../ReelPanel/WinPresentationPanel";


export class View extends FreeGameViewBehavior {
  private freeSpinsText: Label;

  /**
    * Initialize components
    */
  protected initializeComponents(): void {
    super.initializeComponents();
    this.freeSpinsText = this.getLabelById("freespinsLeftText") as Label;
  }
  // Override to change if condition
  public landingAnimation(data: any) {
    const reelgrid = data[0];
    const reelview = data[1];
    const reelId = data[2];
    for (let i = 4; i < reelgrid[reelId].length; i++) {
      if (this.json.reels.symbolData[reelgrid[reelId][i]].hasLanding) {
        const symbol = reelview.getSymbolByPos(reelId, i);
        const staticSym = symbol.getStatic();
        const animSym: SpineBase = symbol.getAnimation() as SpineBase;
        dispatcher.fireEvent(SlotEventConstants.PLAY_LANDING_ANIMATION_SOUND, "scatter_" + reelId);
        if (animSym) {
          const staticSymParent = staticSym.parent;
          if (staticSymParent) {
            staticSym.visible = false;
            animSym.visible = true;
            staticSymParent.addChild(animSym);
            animSym.playAnim("static", false, 0);
            animSym.onComplete.addOnce(() => {
              animSym.playAnim("landing", false);
            }, this);
          }
        }
      }
    }
  }
  /**
   *to set layering 
   */
  public setReelView(reelView: any, pos: any, parentId: any): void {
    this.reelView = reelView;
    this.addChildAt(this.getContainerByID("freegameBgSpineContainer"), 0);
    this.addChildAt(this.getImageById("reelBGFg"), 1);
    this.addChildAt(reelView, 2);
    const container = this.getContainerByID("reelsContainerFg");
    this.addChildAt(container, 3);
    if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
      this.reelView.x = this.reelView.json.portraitX;
      this.reelView.y = this.reelView.json.portraitY;
    }
    this.resize(new Event(EventConstants.RESIZE, ingenuity.deviceEnv.update()));
  }
  /**
   * Function overrided to show freespin text
   */
  public UpdateFreeSpinCounterText() {
    super.UpdateFreeSpinCounterText();
    this.showFreeSpinText();
  }
  /**
   * Function overrided to show freespin text
   */
  public updateNewAwardedFreespinsNumber() {
    super.updateNewAwardedFreespinsNumber();
    this.showFreeSpinText();
  }


  /**
   * Function is used to show free spin text on single freespin
   */
  public showFreeSpinText(): void {
    this.remainingFreespin.visible = false;
    this.freeSpinsText.visible = true;
    let freeCounterText: string
    if (this.remainingFreespin.getValue() <= 1) {
      freeCounterText = this.remainingFreespin.getValue() + " " + ingenuity.currentGame.cache.getJSON("lang").free_Spin.text
    } else {
      freeCounterText = this.remainingFreespin.getValue() + " " + ingenuity.currentGame.cache.getJSON("lang").free_Spins.text
    }
    if (ingenuity.deviceEnv.isDesktop) {
      this.freeSpinsText.setText(freeCounterText)
    } else {
      this.freeSpinsText.text = freeCounterText
    }
  }

  public resizeOrientation(e: IEvent) {
    this.storeLandscapeReelSize();//do not change order
    super.resizeOrientation(e);
    if (ingenuity.deviceEnv.getOrientation() !== detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
      this.scale.set(ingenuity.deviceEnv.getLandcapeMaxReelScale())
      this.y = (innerHeight * SlotConstantsBehavior.HALF_CONVERTER) + ((gameConstants.REEL_BOTTOM_SPACE / 2) * this.scale.x);
      if (!ingenuity.deviceEnv.isDesktop) {
        this.y = (innerHeight * SlotConstantsBehavior.HALF_CONVERTER) + ((gameConstants.REEL_BOTTOM_SPACE_LANDSCAPE / 2) * this.scale.x);
      }
    }else{
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_TOP_GAME_LOGO_FG);
    }
  }

  protected storeLandscapeReelSize(): void {
    gameConstants.REEL_WIDTH = this.getShapeById("freeGameLandscapeResizer").width;
    gameConstants.REEL_HEIGHT = this.getShapeById("freeGameLandscapeResizer").height;
  }
  protected addButtonPanelOnTop() {
    const buttonsContainer = this.getContainerByID("buttonsContainer");
    ingenuity.currentGame.stage.addChild(buttonsContainer);
    const buttonsContainerWidth = buttonsContainer.width;
    if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.LANDSCAPE) {
      buttonsContainer.pivot.set(ingenuity.configData.width / 2, 0);
      const scale = Math.min((window.innerHeight / ingenuity.configData.height), (window.innerWidth / ingenuity.configData.width));
      buttonsContainer.x = (buttonsContainer.width / 2) + ((window.innerWidth - buttonsContainerWidth) / 2);
      buttonsContainer.y = window.innerHeight - (this.getImageById("Button_Panel_Base").height * scale);
      buttonsContainer.scale.set(scale, scale);
    }
    else if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
      buttonsContainer.scale.set(this.portraitPanelSCaling());
      const bottomPanelBgPortrait = this.getImageById("Button_Panel_BasePort");
      bottomPanelBgPortrait && buttonsContainer.pivot.set(bottomPanelBgPortrait.width / 2, bottomPanelBgPortrait.height);
      buttonsContainer.x = window.innerWidth / 2;
      buttonsContainer.y = window.innerHeight;
    }
    this.getContainerByID("portraitButtonsContainer") && ingenuity.currentGame.stage.addChild(this.getContainerByID("portraitButtonsContainer"));
    this.getContainerByID("topPortraitButtonsContainer") && ingenuity.currentGame.stage.addChild(this.getContainerByID("topPortraitButtonsContainer"));

    dispatcher.fireEvent(eventDispatchers.ADD_TOP_BAR_ON_TOP)
    dispatcher.fireEvent(eventDispatchers.ADD_TOP_VIEW_ON_TOP); 
  }
  public onShowPortraitButtonpanel() {
    if (this.PortraitplayerMsgContainer && this.portraitButtonsContainer) {
      this.PortraitplayerMsgContainer.visible = true;
      this.PortraitplayerMsgContainer.y =
      this.getImageById("reelBGFg").y + this.getImageById("reelBGFg").height;
            dispatcher.fireEvent(SlotEventConstantsBehavior.ON_CHANGE_PLAYERMSG_PARENT);
      this.changeParent(this.portraitButtonsContainer);
      const portraitButtonContainerBg = this.getShapeById("portraitBackgroundShape");
      this.portraitButtonsContainer.scale.set(this.portraitPanelSCaling());
      let portraitButtonContainerBgHeight = (portraitButtonContainerBg.height * this.portraitButtonsContainer.scale.x);
      let meterPanelHeight = this.getImageById("Button_Panel_BasePort").height * this.getContainerByID("buttonsContainer").scale.x
      /**
       * to set portait button container y position to - bottom allign
      */
      this.portraitButtonsContainer.pivot.set(ingenuity.configData.width / 2, 0);
      this.portraitButtonsContainer.x = window.innerWidth / 2;
      this.portraitButtonsContainer.y = window.innerHeight - (portraitButtonContainerBgHeight + meterPanelHeight);
      this.portraitButtonsContainer.alpha = 1;
    }
  }
  protected portraitPanelSCaling(): number {
    const viewHeight = (this.getShapeById("freeGameResizer").height / 2) * this.scale.x;
    let remainingHeight = (window.innerHeight / 2) - viewHeight;
    const portraitButtonContainerBg = this.getShapeById("portraitBackgroundShape");
    let availableScaling = this.scalingAvailable(remainingHeight, portraitButtonContainerBg);
    if (availableScaling > SlotConstantsBehavior.FLOATING_MAX_SCALE) {
      availableScaling = SlotConstantsBehavior.FLOATING_MAX_SCALE;
    }
    return availableScaling;
  }
  protected portraitHudOnResize() {
    if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
        this.portraitButtonsContainer && this.onShowPortraitButtonpanel();
    }
    else {
        if (!ingenuity.deviceEnv.isDesktop) {
            this.onHidePortraitButtonPanel();
        }
    }
}
public setWinReelView(value: WinPresentationPanelGame, pos?: number, parentId?: string):void{
  super.setWinReelView(value,pos,parentId);
  this.addChild(this.getImageById("gameLogo"));
}

protected createSpine(json: ISpineData): SpineBase {
  if (Loading.isSpineLoaded(json.image)) {
        //@ts-expect-error
        const spine = new base.Spine(json);
        if (json.parent) {
          this.containers[json.parent].addChild(spine);
        } else {
          this.addChild(spine);
        }
        json.key = json.key ? json.key : json.id;
        this.spines[json.key] = spine;
        this.allComponents[json.id] = spine;
        dispatcher.fireEvent(EventConstants.COMPONENT_CREATED, spine);
        return spine;
      } else {
        dispatcher.on(BaseCoreEventConstants.FILE_LOADED, (evt) => {
          if (
            (evt.data === json.image || evt.data === json.image + ".png" || evt.data === json.image + ".webp") &&
            Loading.isImageLoaded(evt.data)
          ) {
            evt.remove();
            // adding delay so that the currentGame.cache.spine has the entry of the loaded spine, if it is not in cache it does not create the spine and we do not have
            // any event as of now by which we can check if the spine is loaded in the cache after the files are loaded fileLoadComplete on our loader is called before fileLoadComplete of Spine
            // utils.delayedCall(core.base.constants.delayKeys.SPINE_CREATION_DELAY, 1, (jsonArray: ISpineData[]) => {
            this.createSpine(json);
            // }, this, json);
          }
        });
      }
}
}
